const roundTo = (value, numberOfPlaces) => {
    const factor = 10 ** numberOfPlaces;
    return Math.round((value + Number.EPSILON) * factor) / factor;
};

export default roundTo;